import { Component, GondelBaseComponent, EventListener } from '@gondel/core';

/**
 * form module implementation.
 * @author Nikola Antic <nikola.antic@emea.merkleinc.com>
 */

enum Selectors {
	formInput = '.js-m-form__input .a-input__input',
	formButton = '.js-m-form__button',
}
enum States {
	inputError = 'a-input__input--error',
}

@Component('Form')
export class Form extends GondelBaseComponent {
	private _formInputs: NodeListOf<HTMLInputElement> = {} as NodeListOf<HTMLInputElement> ;

	public start() {
		this._formInputs = this._ctx.querySelectorAll(Selectors.formInput);
	}

	@EventListener('click', Selectors.formButton)
	public _onSubmitButtonClick(): void {
		this._formInputs?.forEach((input) => {
			if (!input.checkValidity()) {
				input.classList.add(States.inputError);
			}
		});
	}
}
